module.exports = __webpack_public_path__ + "static/media/sykkel_grey-min.a3138627.png";